module.exports = __webpack_public_path__ + "static/media/Clear_Icon_White.5abf5ae5.svg";